module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Black.4fbd2bf6.otf";